import React from 'react';
import PropTypes from 'prop-types';
import { MentionsInput, Mention } from 'react-mentions';

const mentionStyle = {
  width: '100%',

  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },

  highlighter: {
    overflow: 'hidden',
  },

  input: {
    margin: 0,
  },

  '&singleLine': {
    control: {
      display: 'inline-block',
      width: 130,
    },

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },

    input: {
      padding: 1,

      border: '2px inset',
    },
  },

  '&multiLine': {
    control: {
      fontFamily: 'monospace',
    },

    highlighter: {
      padding: 9,
    },

    input: {
      padding: 9,
      minHeight: 63,
      outline: 0,
      border: 0,
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },

    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',

      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
};

const FormulaField = props => {
  const { onChange, onFocus, onBlur, value, suggestions = [] } = props;

  return (
    <MentionsInput
      id="formula-input"
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      allowSpaceInQuery
      style={mentionStyle}
      value={value}
    >
      <Mention
        trigger={/((\S+))/}
        markup="[__display__]{__id__}"
        data={suggestions}
        renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
          <div className={`column ${focused ? 'focused' : ''}`}>{highlightedDisplay}</div>
        )}
        style={{ backgroundColor: '#cee4e5' }}
        appendSpaceOnAdd
      />
    </MentionsInput>
  );
};

FormulaField.propTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  suggestions: PropTypes.array,
};

FormulaField.defaultProps = {
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  value: '',
  suggestions: [],
};

export default FormulaField;
